import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
  SuperAdminSidenavComponent
} from './sidenav/super-admin-sidenav.component';
import {SharedModule} from "../../shared/shared.module";
import {SuperAdminRouting} from "./super-admin.routing";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {InfiniteScrollModule} from "ngx-infinite-scroll";


@NgModule({
  declarations: [
    SuperAdminSidenavComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    SuperAdminRouting,
    MatProgressSpinnerModule,
    InfiniteScrollModule
  ]
})
export class SuperAdminModule {}
